module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Bezier-curve-6ae82593cf0c0ce426d8dc92160f9690.svg";